import { Directive, ElementRef, AfterViewInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgModel } from '@angular/forms';
declare var CKEDITOR: any;

@Directive({
    selector: '[appCkEditor]',
    providers: [NgModel]
})
export class CkEditorDirective implements AfterViewInit, OnDestroy {
    private ckEditor;
    private ckConfig = {
        toolbar: [
            { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'basicstyles', items: ['Bold', 'Italic', '-', 'RemoveFormat'] },
            { name: 'links', items: ['Link', 'Unlink'] },
            { name: 'lists', items: ['NumberedList', 'BulletedList'] }
        ],
        removePlugins: 'elementspath',
        height: 80
    };

    @Input() set config(value) {
        if (value) {
            this.ckConfig = value;
        }
    }

    @Input() linksDefaultTarget: string = undefined;

    @Output() ngModelChange = new EventEmitter();

    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        if (CKEDITOR) {
            this.ckEditor = CKEDITOR.replace(this.el.nativeElement, this.ckConfig);
            CKEDITOR.on('dialogDefinition', ev => {
                if(this.linksDefaultTarget && this.ckEditor.id === ev.editor.id && ev.data.name == 'link'){
                    ev.data.definition.getContents('target').get('linkTargetType')['default']='_blank';
                }
            });

            this.ckEditor.on('change', (e) => {
                this.ngModelChange.emit(this.ckEditor.getData());
            });
        }
    }

    ngOnDestroy() {
        if (this.ckEditor) {
            this.ckEditor.destroy();
        }
    }
}
